import type { ComponentType } from 'react'
import type { CancelBookingFlowStep } from './types'
import { Button } from '@sunwebgroup/uds-ui/button'
import { useIntl } from '@/intl'
import { getCancelBookingBodyBackButtonConfig } from './cancelBookingOptionRegistry'
import styles from './CancelBookingStep.module.css'
import { CalculateCancellationFeeStep } from './steps/CalculateCancellationFeeStep'
import { FullCancellationConfirmationStep } from './steps/FullCancellationConfirmationStep'
import { PartialCancellationStep } from './steps/PartialCancellationStep'
import { SelectCancelBookingOptionStep } from './steps/SelectCancelBookingOptionStep'
import { VoucherCancellationConfirmationStep } from './steps/VoucherCancellationConfirmationStep'

const CANCEL_BOOKING_STEP_COMPONENTS: Partial<Record<CancelBookingFlowStep, ComponentType>> = {
  'select-option': SelectCancelBookingOptionStep,
  'voucher-cancellation-confirmation': VoucherCancellationConfirmationStep,
  'partial-cancellation': PartialCancellationStep,
  'partial-cancellation-fee': CalculateCancellationFeeStep,
  'full-cancellation-confirmation': FullCancellationConfirmationStep,
}

interface CancelBookingStepContentProps {
  step: CancelBookingFlowStep
  onGoToPreviousStep?: () => void
}

export function CancelBookingStepContent({ step, onGoToPreviousStep }: CancelBookingStepContentProps) {
  const { formatMessage } = useIntl()
  const bodyBackButtonConfig = getCancelBookingBodyBackButtonConfig(step)
  const StepComponent = CANCEL_BOOKING_STEP_COMPONENTS[step]

  return (
    <div className={styles.stepContent}>
      {bodyBackButtonConfig && onGoToPreviousStep && (
        <Button
          type="button"
          variant="transparentNeutral"
          className={styles.bodyBackButton}
          onClick={onGoToPreviousStep}
        >
          <Button.Icon glyph="ChevronLeft" />
          {formatMessage({ id: bodyBackButtonConfig.labelKey })}
        </Button>
      )}
      {StepComponent ? <StepComponent /> : null}
    </div>
  )
}
